import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks/useAuth";
import { IRecipe } from "../../sdk/types";
import { recipes } from "../../sdk/utils/api";

export interface IUseUnpublishRecipeMutationParameters {
    id: string;
}

export const useUnpublishRecipe = (
    invalidQueryKeys: string | string[],
): UseMutationResult<
    IRecipe,
    unknown,
    IUseUnpublishRecipeMutationParameters
> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<IRecipe, unknown, IUseUnpublishRecipeMutationParameters>(
        {
            mutationFn: (parameters: IUseUnpublishRecipeMutationParameters) => {
                if (!auth.token) {
                    throw new Error(
                        "Cannot unpublish recipe without authorization token.",
                    );
                }

                return recipes.Recipe.unpublish({
                    ...parameters,
                    token: auth.token,
                });
            },
            onSuccess: () => {
                queryClient.invalidateQueries(invalidQueryKeys);
            },
        },
    );
};
